const postQuicksight = {
  toastr: 'Usuário adicionado',
  toastr1: ' foi adicionado com sucesso',
  toastrError: 'Resposta já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default postQuicksight;
